import { useEffect, useState } from "react";
import { Download, Loader2, AlertTriangle, CheckCircle2, ChevronDown, ChevronUp } from "lucide-react";
import { subscribeExports, refreshExports, downloadExport, isActive } from "@/lib/exports";

const FMT = { docx: "Word", markdown: "Markdown", epub: "EPUB", pdf: "PDF", kdp: "Publishing Kit", cover: "KDP Cover", readme: "README" };

const JobRow = ({ j }) => (
  <li data-testid={`export-job-${j.id}`} className="flex items-start gap-3 py-2.5 border-t border-gold-500/10 first:border-0">
    <span className="mt-0.5">
      {isActive(j) ? <Loader2 className="w-4 h-4 text-gold-300 animate-spin" />
        : j.status === "completed" ? <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          : <AlertTriangle className="w-4 h-4 text-red-400" />}
    </span>
    <div className="flex-1 min-w-0">
      <p className="font-ui text-sm text-slate-100 truncate">{FMT[j.fmt] || j.fmt} · {j.book_title}</p>
      <p data-testid={`export-job-stage-${j.id}`} className="font-ui text-xs text-slate-400">
        {j.status === "failed" ? (j.error || "Failed") : j.stage}
      </p>
    </div>
    {j.status === "completed" && (
      <button data-testid={`export-job-download-${j.id}`} onClick={() => downloadExport(j.id)}
        className="text-gold-300 hover:text-gold-200 transition-colors" aria-label="Download">
        <Download className="w-4 h-4" />
      </button>
    )}
  </li>
);

export const ExportsTray = ({ bookId }) => {
  const [jobs, setJobs] = useState([]);
  const [open, setOpen] = useState(() => window.innerWidth >= 640);
  useEffect(() => {
    const off = subscribeExports(setJobs);
    refreshExports();
    return off;
  }, []);
  const scoped = bookId ? jobs.filter((j) => j.book_id === bookId) : jobs;
  const active = scoped.filter(isActive).length;
  useEffect(() => { if (active) setOpen(true); }, [active]);
  const recent = scoped.slice(0, 5);
  if (!recent.length) return null;
  return (
    <div data-testid="exports-tray" className="fixed bottom-3 right-3 sm:bottom-5 sm:right-5 z-50 w-[calc(100vw-1.5rem)] max-w-80 sm:w-80 rounded-xl border border-gold-500/20 bg-navy-950/95 backdrop-blur-xl shadow-2xl">
      <button data-testid="exports-tray-toggle" onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 font-ui text-xs uppercase tracking-[0.18em] text-gold-300">
        <span>Exports {active ? `· ${active} in progress` : ""}</span>
        {open ? <ChevronDown className="w-4 h-4" /> : <ChevronUp className="w-4 h-4" />}
      </button>
      {open && <ul className="px-4 pb-3">{recent.map((j) => <JobRow key={j.id} j={j} />)}</ul>}
    </div>
  );
};
